(() => {
  document.querySelectorAll('.js-accordion .accordion-title').forEach((item) => {
    const toggleAccordion = (e) => {
      // Close other accordions
      if (!e.classList.contains('nActive')) {
        e.closest('.js-accordion').querySelectorAll('.nActive').forEach((accordion) => {
          accordion.classList.remove('nActive');
        });
      }

      // toggle clicked accordion
      e.classList.toggle('nActive');
    };

    item.addEventListener('click', () => {
      toggleAccordion(item);
    });

    item.addEventListener('keyup', (e) => {
      if (!(e.key === 'Enter')) return;
      toggleAccordion(item);
    });
  });
})();
